const DEFAULT_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const DEFAULT_WARNING_DURATION_MS = 2 * 60 * 1000;
const MIN_TIMEOUT_MS = 60 * 1000;
const MIN_WARNING_MS = 30 * 1000;

const parsePositiveMs = (rawValue: unknown): number | null => {
  if (typeof rawValue !== 'string' || rawValue.trim().length === 0) {
    return null;
  }

  const parsed = Number(rawValue.trim());
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }

  return Math.floor(parsed);
};

export type SessionTimeoutConfig = {
  idleTimeoutMs: number;
  warningDurationMs: number;
};

export function getSessionTimeoutConfig(): SessionTimeoutConfig {
  const timeoutFromEnv = parsePositiveMs(import.meta.env.VITE_IDLE_SESSION_TIMEOUT_MS);
  const warningFromEnv = parsePositiveMs(import.meta.env.VITE_IDLE_SESSION_WARNING_MS);

  const idleTimeoutMs = Math.max(MIN_TIMEOUT_MS, timeoutFromEnv ?? DEFAULT_IDLE_TIMEOUT_MS);
  const warningDurationMs = Math.min(
    Math.max(MIN_WARNING_MS, warningFromEnv ?? DEFAULT_WARNING_DURATION_MS),
    idleTimeoutMs - MIN_WARNING_MS
  );

  return { idleTimeoutMs, warningDurationMs };
}
